// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__33tKk","info":"UpdateTermsInfo_info__IYbgB"};